<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
                clearable
                clear-icon="mdi-close-circle"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getData()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="green"
              class="white--text"
              @click="(dialogAdd = true), validate('ADD'), getDataEmployee()"
            >
              เพิ่มข้อมูล
              <v-icon right dark> mdi-plus </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportData()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- data table -->

        <!-- ADD -->
        <v-dialog v-model="dialogAdd" max-width="80%">
          <v-card>
            <v-card-title>
              <span class="text-h5">ขอเบิกสวัสดิการ</span>
            </v-card-title>
            <v-form
    ref="form_add"
    v-model="valid_add"
    lazy-validation
  >
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="10">
                    <v-autocomplete
                      v-model="profile"
                      :items="dataItemEmployee"
                      :rules="nameRules"
                      required
                      dense
                      outlined
                      clear-icon="mdi-close-circle"
                      prepend-icon="mdi-account-star"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="[
                        'เบิกค่าอบรม',
                        'เบิกค่าอบรม(ภายนอก)',
                        'สวัสดิการเครื่องแบบ',
                        'เงินสนับสนุนกิจกรรมพิเศษ',
                        'เงินช่วยเหลือค่าที่พัก(นักศึกษา)',
                        'เงินช่วยเหลือค่ารักษาพยาบาล(นักศึกษา)',
                      ]"
                      label="รายการเบิก*"
                      v-model="formAdd.welfareRequest"
                      required
                      :rules="nameRules"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="ยอดที่เบิก"
                      v-model="formAdd.welfareAmount"
                      :rules="nameRules"
                      multiple
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*แนบไฟล์ เอกสารประกอบ</small>
              <v-file-input
                v-model="files"
                @change="fileupload()"
                show-size
                accept="image/*,.pdf"
                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                :rules="imageRules"
                required
              ></v-file-input>
              <v-file-input
                v-model="files2"
                @change="fileupload2()"
                show-size
                accept="image/*,.pdf"
                :rules="imageRules"
                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                required
              ></v-file-input>
              <v-file-input
                v-model="files3"
                @change="fileupload3()"
                show-size
                accept="image/*,.pdf"
                :rules="imageRules"
                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                required
              ></v-file-input>
              <v-file-input
                v-model="files4"
                @change="fileupload4()"
                show-size
                accept="image/*,.pdf"
                :rules="imageRules"
                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                required
              ></v-file-input>
              <v-file-input
                v-model="files5"
                @change="fileupload5()"
                show-size
                accept="image/*,.pdf"
                :rules="imageRules"
                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                required
              ></v-file-input>
              <v-col
        cols="12"
      >
        <v-textarea
          outlined
          v-model="formAdd.welfareRemark"
          :rules="nameRules"
          rows="2"
          row-height="20"
          label="หมายเหตุ"
         ></v-textarea>
      </v-col>
            </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogAdd = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text :disabled="!valid_add" @click="addData(formAdd)">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end add -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>สวัสดิการ</td>
                            <td>{{ dateItemInfo.welfareRequest }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td v-if="dateItemInfo.welfare_status == 'draft'">
                              รอตรวจสอบเอกสาร
                            </td>
                            <td v-if="dateItemInfo.welfare_status == 'verify'">
                              รอผู้จัดการอนุมัติ
                            </td>
                          </tr>
                          <tr>
                            <td>ยอดเบิก</td>
                            <td>
                              <v-text-field
                                v-model="dateItemInfo.welfareAmount"
                              ></v-text-field>
                            </td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบ</td>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile"
                                v-model="filesedit"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile && dateItemInfo.welfareFile == 'None'"
                                v-model="filesedit"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="dateItemInfo.welfare_status == 'verify' && dateItemInfo.welfareFile == 'None'"
                                v-model="filesedit"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <a
                                :href="dateItemInfo.welfareFile"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                              <v-icon
                              color="red"
                              v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'"
                              @click="deleteField(dateItemInfo)"
                              > mdi-delete-circle
                              </v-icon>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile2"
                                v-model="filesedit2"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 == 'None'"
                                v-model="filesedit2"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="dateItemInfo.welfare_status == 'verify' && dateItemInfo.welfareFile2 == 'None'"
                                v-model="filesedit2"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <a
                                :href="dateItemInfo.welfareFile2"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                              <v-icon
                              color="red"
                              v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'"
                              @click="deleteField2(dateItemInfo)"
                              > mdi-delete-circle
                              </v-icon>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile3"
                                v-model="filesedit3"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 == 'None'"
                                v-model="filesedit3"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="dateItemInfo.welfare_status == 'verify' && dateItemInfo.welfareFile3 == 'None'"
                                v-model="filesedit3"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <a
                                :href="dateItemInfo.welfareFile3"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                              <v-icon
                              color="red"
                              v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'"
                              @click="deleteField3(dateItemInfo)"
                              > mdi-delete-circle
                              </v-icon>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile4"
                                v-model="filesedit4"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 == 'None'"
                                v-model="filesedit4"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="dateItemInfo.welfare_status == 'verify' && dateItemInfo.welfareFile4 == 'None'"
                                v-model="filesedit4"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <a
                                :href="dateItemInfo.welfareFile4"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                              <v-icon
                              color="red"
                              v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'"
                              @click="deleteField4(dateItemInfo)"
                              > mdi-delete-circle
                              </v-icon>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile5"
                                v-model="filesedit5"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="!dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 == 'None'"
                                v-model="filesedit5"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <v-file-input
                                v-if="dateItemInfo.welfare_status == 'verify' && dateItemInfo.welfareFile5 == 'None'"
                                v-model="filesedit5"
                                show-size
                                accept="image/*,.pdf"
                                placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                                :rules="imageRules"
                                dense
                                required
                              ></v-file-input>
                              <a
                                :href="dateItemInfo.welfareFile5"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                              <v-icon
                              color="red"
                              v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'"
                              @click="deleteField5(dateItemInfo)"
                              > mdi-delete-circle
                              </v-icon>
                            </td>
                          </tr>
                          <tr>
                            <td>หมายเหตุ</td>
                            <td>
                              <v-textarea
                                rows="3"
                                row-height="25"
                                v-model="dateItemInfo.welfareRemark"
                              ></v-textarea>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
              <v-btn
              v-if="dateItemInfo.welfare_status == 'draft'"
                elevation="2"
                x-large
                color="success"
                text
                @click="(dialog = false), approve(dateItemInfo, 'verify')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                ผ่าน
              </v-btn>
              <v-btn
              v-if="dateItemInfo.welfare_status == 'draft'"
                elevation="2"
                x-large
                color="red"
                text
                @click="(dialog = false), approve(dateItemInfo, 'cancel')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่ผ่าน
              </v-btn>
              <v-btn
              v-if="dateItemInfo.welfare_status == 'verify'"
                elevation="2"
                x-large
                color="green "
                text
                @click="(dialog = false), editData(dateItemInfo)"
              >
                <v-icon left> mdi-account-edit </v-icon>
                แก้ไข
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogView" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>สวัสดิการ</td>
                            <td>{{ dateItemInfo.welfareRequest }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td v-if="dateItemInfo.welfare_status == 'verify'">
                              รอผจก สาขา อนุมัติ
                            </td>
                            <td v-if="dateItemInfo.welfare_status == 'confirm'">
                              รอผจก HR อนุมัติ
                            </td>
                            <td v-if="dateItemInfo.welfare_status == 'approve'">
                              รอตรวจสอบเอกสารและอนุมัติจากบัญชี
                            </td>
                            <td
                              v-if="dateItemInfo.welfare_status == 'unapprove'"
                            >
                              ไม่อนุมัติ
                            </td>
                            <td v-if="dateItemInfo.welfare_status == 'cancel'">
                              ไม่ผ่านการตรวจสอบเอกสาร
                            </td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบ</td>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile2"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile3"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile4"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile5"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogView = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialogEdit" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการขอสวัสดิการ</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>สวัสดิการ</td>
                            <td>{{ dateItemInfo.welfareRequest }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td v-if="dateItemInfo.welfare_status == 'finish'">
                              ผ่านการตรวจสอบและอนุมัติจากบัญชี
                            </td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบจากบัญชี</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFileUpdate"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFileUpdate"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>ไฟล์แนบพนักงาน</td>
                            <td>
                            </td>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile2"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile3"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile4"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <a
                                :href="dateItemInfo.welfareFile5"
                                target="_blank"
                                download
                                v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'"
                              >
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                dark
                color="#C62929"
                @click="sendLinePushEmployee(dateItemInfo)"
              >
                <v-icon left> mdi-send </v-icon>
                แจ้งพนักงานรับทราบ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogEdit = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

         <!-- รายละเอียด ไฟล์ -->
        <v-dialog v-model="dialogFile" persistent max-width="80%">
          <v-card>
            <div class="container d-flex justify-content-center mb-50">
      <div class="row">
        <div class="col-md-12">
          <div class="card" id="invoice">
            <div class="row card-header bg-transparent header-elements-inline">
              <img :src="require('@/assets/Icon/logo_Honda_3D.png')" width="80" height="60">
              <img :src="require('@/assets/Icon/LOGO_VGxLIA.png')" width="80" height="40">
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-6">
                  <!-- <div class="mb-4 pull-left">
                    <ul class="list list-unstyled mb-0 text-left">
                      <li>{{dateItemInfo.empFull_NameTH}}</li>
                    </ul>
                    <ul class="list list-unstyled mb-0 text-left">
                      <li>ตำแหน่ง : {{dateItemInfo.positionName}}</li>
                    </ul>
                    <ul class="list list-unstyled mb-0 text-left">
                      <li>แผนก : {{dateItemInfo.masDepartmentName}}</li>
                    </ul>
                    <ul class="list list-unstyled mb-0 text-left">
                      <li>สาขา : {{dateItemInfo.masBranchName}}</li>
                    </ul>
                    <ul class="list list-unstyled mb-0 text-left">
                      <li>บริษัท : {{dateItemInfo.masCompanyName}}</li>
                    </ul>
                  </div> -->
                </div>
                <div class="col-sm-6">
                  <div class="mb-4">
                    <div class="text-sm-right">
                      <ul class="list list-unstyled mb-0">
                        <li>
                          วันที่:
                          <span class="font-weight-semibold"
                            >{{computedDateEMP}}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-5 ml-auto">
                <h6 class="card-title text-center ">แบบฟอร์มขอรับสวัสดิการพนักงาน</h6>
                  <div class="mb-2 ml-auto">
                    <v-simple-table>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">สาขา</th>
                              <th class="text-center">บริษัท</th>
                              <th class="text-center">ชื่อพนักงาน</th>
                              <th class="text-center">ตำแหน่งงาน</th>
                              <th class="text-center">รายการ</th>
                              <th class="text-center">จำนวนเงิน</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{dateItemInfo.masBranchName}}</td>
                              <td>{{dateItemInfo.masCompanyName}}</td>
                              <td>{{dateItemInfo.empFull_NameTH}}</td>
                              <td>{{dateItemInfo.positionName}}</td>
                              <td>{{dateItemInfo.welfareRequest}}</td>
                              <td>{{dateItemInfo.welfareAmount}}</td>
                            </tr>
                          </tbody>
                      </v-simple-table>
                  </div>
              </div>
              <div class="mb-5 ml-auto">
                  <div class="d-flex flex-wrap wmin-md-400">
                     <span class="text-muted">รายการอนุมัติ:</span>
                  </div>
                  <v-row cols="10" class="justify-content-center">
                  <v-col cols="5" class="pr-16 mr-16">
                  <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u>_{{dateItemInfo.empFirst_NameTH_GA}}_</u><br>
                      <li>({{dateItemInfo.empFull_NameTH_GA}})</li><br>
                      <li>{{dateItemInfo.positionName_GA}}</li><br>
                      <li>Prepared</li><br>
                      <li>{{computedDateGA}}</li>
                    </ul>
                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">
                    <ul class="list list-unstyled mb-0 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u>_{{dateItemInfo.empFirst_NameTH_HR}}_</u><br>
                      <li>({{dateItemInfo.empFull_NameTH_HR}})</li><br>
                      <li>{{dateItemInfo.positionName_HR}}</li><br>
                      <li>Concurred(2)</li><br>
                      <li>{{computedDateHR}}</li>
                    </ul>
                  </div>
                </v-col>
                  <v-col cols="5" class="pl-16 ml-16">
                  <div class=" mt-6 mb-5 text-center">

                    <ul class="list list-unstyled mb-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <u>_{{dateItemInfo.empFirst_NameTH_MGR}}_</u><br>
                      <li>({{dateItemInfo.empFull_NameTH_MGR}})</li><br>
                      <li>{{dateItemInfo.positionName_MGR}}</li><br>
                      <li>Concurred(1)</li><br>
                      <li>{{computedDateMGR}}</li>
                    </ul>

                  </div>
                    <br />
                    <div class=" mt-6 mb-5 text-center">

                    <ul class="list list-unstyled mb-0 ml-6 text-center">
                      <!-- <img  width="70" height="50"><br> -->
                      <!-- <u>_นางศิริวัลย์_</u><br> -->
                      <li>(นางศิริวัลย์ อุชุกานนท์ชัย)</li><br>
                      <li>CEO Board</li><br>
                      <li>Approved</li><br>
                      <li>{{computedDateCEO}}</li>
                    </ul>
                  </div>
                </v-col>
                  </v-row>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="text-h5 mb-4">ดาวน์โหลด ไฟล์แนบ</div>
    <a :href="dateItemInfo.welfareFile"  target="_blank" download v-if="dateItemInfo.welfareFile && dateItemInfo.welfareFile != 'None'">
      <b>[File Download]</b>
    </a>
    <a :href="dateItemInfo.welfareFile2"  target="_blank" download v-if="dateItemInfo.welfareFile2 && dateItemInfo.welfareFile2 != 'None'">
      <b>[File Download]</b>
    </a>
    <a :href="dateItemInfo.welfareFile3"  target="_blank" download v-if="dateItemInfo.welfareFile3 && dateItemInfo.welfareFile3 != 'None'">
      <b>[File Download]</b>
    </a>
    <a :href="dateItemInfo.welfareFile4"  target="_blank" download v-if="dateItemInfo.welfareFile4 && dateItemInfo.welfareFile4 != 'None'">
      <b>[File Download]</b>
    </a>
    <a :href="dateItemInfo.welfareFile5"  target="_blank" download v-if="dateItemInfo.welfareFile5 && dateItemInfo.welfareFile5 != 'None'">
      <b>[File Download]</b>
    </a>
    <div class="text-h5 mb-4">ไฟล์แนบจากบัญชี</div>
      <a
        :href="dateItemInfo.welfareFileUpdate"
        target="_blank"
        download
        v-if="dateItemInfo.welfareFileUpdate"
      >
        <b>[File Download]</b>
      </a>
    </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="mr-6">
          <download-button
            class="btn btn-primary"
            dom="#invoice"
            name="สวัสดิการพนักงาน.pdf"
          />
        </div>

        <v-btn
                elevation="2"
                x-large
                dark
                color="#C62929"
                @click="sendLinePushEmployee(dateItemInfo)"
              >
                <v-icon left> mdi-send </v-icon>
                แจ้งพนักงานรับทราบ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogFile = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end รายละเอียด -->

        <!-- รายการขอ -->
        <v-col cols="12">
          <v-alert dense type="info" icon="mdi-file-account">
            รายการ <strong>ขอสวัสดิการ</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItem"
                :search="searchAll"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialog = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
        <!-- รอ ผจก สาขา -->
        <v-col cols="12">
          <v-alert dense type="warning" icon="mdi-file-account">
            รายการ <strong>รอ ผู้จัดการสาขา อนุมัติ</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll1"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemVerify"
                :search="searchAll1"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialog = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
        <!-- รอ ผจก HR -->
        <v-col cols="12">
          <v-alert dense color="#C51162" dark icon="mdi-file-account">
            รายการ <strong>รอ ผู้จัดการแผนกทรัพยากรบุคคล อนุมัติ</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll1"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemConfirm"
                :search="searchAll1"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogView = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
        <!-- รอ การเงิน -->
        <v-col cols="12">
          <v-alert
            dense
            color="deep-purple accent-4"
            dark
            icon="mdi-file-account"
          >
            รายการ <strong>รอ บัญชี ตรวจสอบและอนุมัติ</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll1"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemApprove"
                :search="searchAll1"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogView = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
        <!-- ผ่านการเงิน -->
        <v-col cols="12">
          <v-alert dense type="success" icon="mdi-file-account">
            รายการ <strong>ผ่านการตรวจสอบและอนุมัติจากบัญชี</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemAuditApprove"
                :search="searchAll2"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogFile = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
        <!-- เอกสารไม่ผ่าน -->
        <v-col cols="12">
          <v-alert dense type="error" icon="mdi-file-account">
            รายการ <strong>ไม่ผ่านการตรวจสอบเอกสาร</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemCancel"
                :search="searchAll2"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogView = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
        <!-- ไม่อนุมัติ -->
        <v-col cols="12">
          <v-alert dense type="error" icon="mdi-file-account">
            รายการ <strong>ไม่อนุมัติ</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-text-field
                v-model="searchAll2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemUnApprove"
                :search="searchAll2"
                :items-per-page="10"
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), (dialogView = true)"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <!-- end data table -->
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment'
import DownloadButton from '../Special/DownloadButton.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    DownloadButton
  },
  computed: {
    computedDateEMP () {
      if (this.dateItemInfo.welfare_date) {
        let dateThEMP = moment(this.dateItemInfo.welfare_date)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTHEMP = dateThEMP
        return this.showDateTHEMP
      }
    },
    computedDateGA () {
      if (this.dateItemInfo.LAST_DATE_GA) {
        let dateTh = moment(this.dateItemInfo.LAST_DATE_GA)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH = dateTh
        return this.showDateTH
      }
    },
    computedDateHR () {
      if (this.dateItemInfo.LAST_DATE_HR) {
        let dateTh1 = moment(this.dateItemInfo.LAST_DATE_HR)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH2 = dateTh1
        return this.showDateTH2
      }
    },
    computedDateMGR () {
      if (this.dateItemInfo.LAST_DATE_MGR) {
        let dateTh2 = moment(this.dateItemInfo.LAST_DATE_MGR)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH3 = dateTh2
        return this.showDateTH3
      }
    },
    computedDateCEO () {
      if (this.dateItemInfo.LAST_DATE) {
        let dateTh4 = moment(this.dateItemInfo.LAST_DATE)
          .locale('th')
          .add(543, 'year')
          .format('LL')
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.showDateTH4 = dateTh4
        return this.showDateTH4
      }
    }
  },
  data () {
    return {
      showDateTH: '',
      showDateTH2: '',
      showDateTH3: '',
      showDateTH4: '',
      path: '/welfare/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สวัสดิการพนักงาน สำหรับ HR ตรวจสอบ',
          disabled: true,
          href: '/Master/welfareRequest'
        }
      ],
      dialog: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogView: false,
      dialogFile: false,
      session: this.$session.getAll(),
      loading: false,
      dataReady: true,
      searchAll: '',
      searchAll1: '',
      searchAll2: '',
      formAdd: [],
      profile: '',
      valid_add: true,
      columnsItem: [
        // { text: 'ID', value: 'welfareID' },
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'สวัสดิการ', value: 'welfareRequest' },
        { text: 'ยอดเบิก', value: 'welfareAmount' },
        { text: 'หมายเหตุ', value: 'welfareRemark' },
        { text: 'วันที่ทำรายการ', value: 'welfare_date' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      dataItemApprove: [],
      dataItemConfirm: [],
      dataItemVerify: [],
      dataItemUnApprove: [],
      dataItemAuditApprove: [],
      dataItemCancel: [],
      dateItemInfo: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // สาขา
      Department: '', // แผนก
      day: '',
      month: '',
      year: '',
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      files: null,
      files2: null,
      files3: null,
      files4: null,
      files5: null,
      filesedit: null,
      filesedit2: null,
      filesedit3: null,
      filesedit4: null,
      filesedit5: null,
      dataItemEmployee: [],
      nameRules: [(v) => !!v || 'กรุณากรอกข้อมูล'],
      imageRules: [
        (value) =>
          !value || value.size < 5000000 || 'size should be less than 5 MB!'
      ],
      profileHR: []
    }
  },
  async mounted () {
    let date = new Date()
    this.day = date.getDate()
    this.month = this.getMonthTh()
    this.year = moment().format('YYYY')

    await this.getData()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    // await this.getEmployee()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getData () {
      await this.getDataWaiting()
      await this.getDataApprove()
      await this.getDataConfirm()
      await this.getDataVerify()
      await this.getDataUnApprove()
      await this.getDataAuditApprove()
      await this.getDataCancel()
    },
    async getDataWaiting () {
      this.dataItem = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=draft' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItem = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataApprove () {
      this.dataItemApprove = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=approve' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemApprove = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataConfirm () {
      this.dataItemConfirm = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=confirm' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemConfirm = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataUnApprove () {
      this.dataItemUnApprove = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=unapprove' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemUnApprove = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataVerify () {
      this.dataItemVerify = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=verify' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemVerify = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataAuditApprove () {
      this.dataItemAuditApprove = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=finish' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemAuditApprove = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataCancel () {
      this.dataItemCancel = []

      // this.day = this.day ? this.day : null
      this.month = this.month ? this.month : null
      this.Department = this.Department ? this.Department : null
      this.Branch = this.Branch ? this.Branch : null
      this.Company = this.Company ? this.Company : null

      var monthSearch =
        this.month !== null
          ? '&welfare_month=' + this.getMonthThToINT(this.month)
          : ''
      // var daySearch = this.day !== null ? '&welfare_day=' + this.day : ''
      var Department =
        this.Department !== null ? '&masDepartmentName=' + this.Department : ''
      var Branch = this.Branch !== null ? '&masBranchName=' + this.Branch : ''
      var Company =
        this.Company !== null ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/welfare/get?welfare_status=cancel' +
            '&welfare_year=' +
            this.year +
            monthSearch +
            Company +
            Branch +
            Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            this.dataItemCancel = response.data
          }
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async addData (itemAdd) {
      this.dataReady = true
      let date = new Date()
      let month = date.getMonth() + 1
      let year = this.year !== '' ? this.year : moment().format('YYYY')
      let day = this.day !== '' ? this.day : moment().format('D')

      // if (this.files) {
      //   await this.fileupload()
      // }
      // if (this.files2) {
      //   await this.fileupload2()
      // }
      // if (this.files3) {
      //   await this.fileupload3()
      // }
      // if (this.files4) {
      //   await this.fileupload4()
      // }
      // if (this.files5) {
      //   await this.fileupload5()
      // }

      let ds = {
        empCode: this.profile.empCode,
        welfare_year: year,
        welfare_month: month,
        welfare_day: day,
        welfare_date: year + '-' + month + '-' + day,
        welfare_status: 'draft',
        welfareAmount: itemAdd.welfareAmount,
        welfareRequest: itemAdd.welfareRequest,
        welfareRemark: itemAdd.welfareRemark,
        welfareFile: itemAdd.welfareFile,
        welfareFile2: itemAdd.welfareFile2,
        welfareFile3: itemAdd.welfareFile3,
        welfareFile4: itemAdd.welfareFile4,
        welfareFile5: itemAdd.welfareFile5,
        CREATE_USER: this.session.data.userName,
        LAST_USER: this.session.data.userName
      }
      console.log('ds', ds)
      this.addDataSubmit(ds)
      await this.linenotify(ds, this.profile)
    },
    async addDataSubmit (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/welfare/add",
          ds
        )
        .then(async (response) => {
          this.$swal('เรียบร้อย', 'บันทึกข้อมูล เรียบร้อย', 'success')
          this.dialogAdd = false
          await this.getData()
          this.clearData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
      this.dataReady = true
    },
    async linenotify (dt, item) {
      console.log('dt', dt)
      var massageNoti = 'ขอ' + dt.welfareRequest +
            '\nชื่อพนักงาน : ' + item.empFull_NameTH +
            '\nแผนก : ' + item.masDepartmentName +
            '\nสาขา : ' + item.masBranchName +
            '\nบริษัท : ' + item.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + item.empTel +
            '\nหมายเหตุ : ' + dt.welfareRemark
      let ds = {
        token: 'ykOxnleuJDAAnR6CwdI98b7PJYidormK5ZdvOApt54Q', // token
        message: massageNoti // text
      }
      let url = this.DNS_IP + '/line/hrm_notify'
      await axios.post(url, ds)
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      params.append('profile', _this.session.data)
      console.log('this.files', _this.files)
      console.log('this.files', _this.files.size)
      console.log('URL', _this.DNS_IP_UPLOAD + '/upload')
      console.log('params', params)

      if (_this.files.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.formAdd.welfareFile = _this.DNS_IP_UPLOAD + '/' + response.data
            }).catch((error) => {
              alert(error)
              _this.formAdd.welfareFile = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.files = null
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files = null
      }
    },
    async fileupload2 () {
      const _this = this
      let params = new FormData()

      if (_this.files2.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files2)
        params.append('profile', _this.session.data)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file2', response)
              _this.formAdd.welfareFile2 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile2 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files2 = null
        }

        console.log('this.files2', _this.formAdd.welfareFile2)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files2 = null
      }
    },
    async fileupload3 () {
      const _this = this
      let params = new FormData()

      if (_this.files3.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files3)
        params.append('profile', _this.session.data)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file3', response)
              _this.formAdd.welfareFile3 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile3 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files3 = null
        }

        console.log('this.files3', _this.formAdd.welfareFile3)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files3 = null
      }
    },
    async fileupload4 () {
      const _this = this
      let params = new FormData()

      if (_this.files4.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files4)
        params.append('profile', _this.session.data)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file4', response)
              _this.formAdd.welfareFile4 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile4 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files4 = null
        }

        console.log('this.files4', _this.formAdd.welfareFile4)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files4 = null
      }
    },
    async fileupload5 () {
      const _this = this
      let params = new FormData()

      if (_this.files5.size < 5000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files5)
        params.append('profile', _this.session.data)
        console.log(_this.DNS_IP_UPLOAD + '/upload')
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file5', response)
              _this.formAdd.welfareFile5 = _this.DNS_IP_UPLOAD + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.formAdd.welfareFile5 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.files5 = null
        }

        console.log('this.files5', _this.formAdd.welfareFile5)
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.files5 = null
      }
    },
    async fileEditupload () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.filesedit)
      params.append('profile', _this.session.data)

      if (_this.filesedit.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.dateItemInfo.welfareFile =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              _this.dateItemInfo.welfareFile = null
              return null
            })
        } catch (error) {
          alert(error)
          _this.filesedit = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.filesedit = null
      }
    },
    async fileEditupload2 () {
      const _this = this
      let params = new FormData()

      if (_this.filesedit2.size < 5000000) {
        params.append('file', _this.filesedit2)
        params.append('profile', _this.session.data)
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              _this.dateItemInfo.welfareFile2 =
                _this.DNS_IP_UPLOAD + '/' + response.data
            }) // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.dateItemInfo.welfareFile2 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.filesedit2 = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.filesedit2 = null
      }
    },
    async fileEditupload3 () {
      const _this = this
      let params = new FormData()

      if (_this.filesedit3.size < 5000000) {
        params.append('file', _this.filesedit3)
        params.append('profile', _this.session.data)
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              _this.dateItemInfo.welfareFile3 =
                _this.DNS_IP_UPLOAD + '/' + response.data
            }) // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.dateItemInfo.welfareFile3 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.filesedit3 = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.filesedit3 = null
      }
    },
    async fileEditupload4 () {
      const _this = this
      let params = new FormData()

      if (_this.filesedit4.size < 5000000) {
        params.append('file', _this.filesedit4)
        params.append('profile', _this.session.data)
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              _this.dateItemInfo.welfareFile4 =
                _this.DNS_IP_UPLOAD + '/' + response.data
            }) // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.dateItemInfo.welfareFile4 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.filesedit4 = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.filesedit4 = null
      }
    },
    async fileEditupload5 () {
      const _this = this
      let params = new FormData()

      if (_this.filesedit5.size < 5000000) {
        params.append('file', _this.filesedit5)
        params.append('profile', _this.session.data)
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.session.data.empCode,
                Topic: 'Welfare'
              }
            })
            .then(function (response) {
              _this.dateItemInfo.welfareFile5 =
                _this.DNS_IP_UPLOAD + '/' + response.data
            }) // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              _this.dateItemInfo.welfareFile5 = null
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
          _this.filesedit5 = null
        }
      } else {
        alert('ขนาดไฟล์ใหญ่เกิน')
        _this.filesedit5 = null
      }
    },
    async getDataById (item) {
      this.dateItemInfo = []
      this.dateItemInfo = item
      await this.getEmployeeApproveHR(item)
    },
    async getEmployeeApproveHR (item) {
      this.profileHR = []
      // var message = 'คำเตือน : ไม่พบข้อมูลหัวหน้าของท่าน ระบบไม่สามารถส่งการแจ้งเตือนได้ กรุณาติดต่อฝ่ายบุคคล'
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/approve_permission/get?empCode=" + item.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.profileHR = response.data[0].userLineuserId_manager
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async approve (item, status) {
      var statusName =
        status === 'verify'
          ? 'อนุมัติ'
          : status === 'cancel'
            ? 'ไม่อนุมัติ'
            : 'ยกเลิก'
      this.$swal({
        title: 'ท่านต้องการ ' + statusName + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          if (this.filesedit) {
            await this.fileEditupload()
          }
          if (this.filesedit2) {
            await this.fileEditupload2()
          }
          if (this.filesedit3) {
            await this.fileEditupload3()
          }
          if (this.filesedit4) {
            await this.fileEditupload4()
          }
          if (this.filesedit5) {
            await this.fileEditupload5()
          }

          let ds = {
            // welfareID: item.welfareID,
            welfare_status: status,
            welfareAmount: item.welfareAmount,
            welfareRemark: item.welfareRemark,
            welfareFile: item.welfareFile,
            welfareFile2: item.welfareFile2,
            welfareFile3: item.welfareFile3,
            welfareFile4: item.welfareFile4,
            welfareFile5: item.welfareFile5,
            LAST_USER: this.session.data.userName,
            LAST_USER_GA: this.session.data.empCode
          }
          console.log('DS', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/edit/" + item.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
              await this.setUpBeforeSendLine(item)
              await this.getData()
              // this.dataReady = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    async editData (item) {
      this.dataReady = true
      this.$swal({
        title: 'ท่านต้องการ ' + 'แก้ไขข้อมูล' + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          if (this.filesedit) {
            await this.fileEditupload()
          }
          if (this.filesedit2) {
            await this.fileEditupload2()
          }
          if (this.filesedit3) {
            await this.fileEditupload3()
          }
          if (this.filesedit4) {
            await this.fileEditupload4()
          }
          if (this.filesedit5) {
            await this.fileEditupload5()
          }

          let ds = {
            welfareAmount: item.welfareAmount,
            welfareRemark: item.welfareRemark,
            welfareFile: item.welfareFile,
            welfareFile2: item.welfareFile2,
            welfareFile3: item.welfareFile3,
            welfareFile4: item.welfareFile4,
            welfareFile5: item.welfareFile5,
            LAST_USER: this.session.data.userName,
            LAST_USER_GA: this.session.data.empCode
          }
          console.log('DS', ds)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/edit/" + item.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    async setUpBeforeSendLine (item) {
      console.log('item', item)
      var payload = [
        {
          type: 'flex',
          altText: 'ขอสวัสดิการ',
          contents: {
            type: 'bubble',
            header: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'text',
                  text: 'แจ้งเตือนการร้องขอสวัสดิการ',
                  offsetBottom: 'none',
                  offsetTop: 'xs',
                  weight: 'bold',
                  position: 'relative',
                  align: 'start',
                  wrap: true
                }
              ],
              offsetBottom: 'md',
              backgroundColor: '#FFB8A1'
            },
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'horizontal',
                  contents: [
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'image',
                          url: 'https://api.betaskthai.com/upload/static/upload/Welfare/2022_09/EMP20218193_2022_09_30_16_49_50.png',
                          size: 'full',
                          margin: 'lg'
                        }
                      ],
                      cornerRadius: '100px',
                      width: '72px',
                      height: '72px'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          contents: [
                            {
                              type: 'span',
                              text: 'รอตรวจสอบเอกสารและผู้จัดการอนุมัติ',
                              weight: 'bold',
                              color: '#000000'
                            },
                            {
                              type: 'span',
                              text: '|'
                            }
                          ],
                          size: 'sm',
                          wrap: true
                        },
                        {
                          type: 'text',
                          text: 'hello, world',
                          contents: [
                            {
                              type: 'span',
                              text: item.welfareRequest,
                              color: '#D81B60'
                            }
                          ]
                        },
                        {
                          type: 'text',
                          text: 'hello, world',
                          contents: [
                            {
                              type: 'span',
                              text: item.empFull_NameTH,
                              color: '#1A237E'
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  spacing: 'xl',
                  paddingAll: '20px',
                  paddingTop: 'xs',
                  paddingBottom: 'xs'
                },
                {
                  type: 'separator'
                },
                {
                  type: 'box',
                  layout: 'baseline',
                  contents: [
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ',
                      flex: 1,
                      size: 'sm',
                      color: '#aaaaaa',
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.welfare_date,
                      size: 'sm',
                      color: '#666666',
                      wrap: true,
                      flex: 1,
                      align: 'center'
                    }
                  ],
                  paddingTop: 'md'
                }
              ],
              paddingAll: '0px',
              offsetTop: 'xs',
              spacing: 'none'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบสถานะ',
                    uri: 'line://app/1654154168-JML0KbN5?page=WelfareHistoryBranch'
                  },
                  style: 'primary',
                  color: '#FFB8A1'
                }
              ]
            }
          }
        }
      ]
      console.log('payload', payload)
      await this.sendLinePush(payload, this.profileHR)
      this.dataReady = false
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {})
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {})
    },
    async sendLinePushEmployee (item) {
      var payload = [
        {
          type: 'flex',
          altText: 'อนุมัติสวัสดิการ',
          contents: {
            type: 'bubble',
            header: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'text',
                  text: 'แจ้งเตือนการอนุมัติสวัสดิการ',
                  offsetBottom: 'none',
                  offsetTop: 'xs',
                  weight: 'bold',
                  position: 'relative',
                  align: 'start',
                  wrap: true
                }
              ],
              offsetBottom: 'md',
              backgroundColor: '#7CB342'
            },
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'horizontal',
                  contents: [
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'image',
                          url: 'https://api.betaskthai.com/upload/static/upload/Welfare/2022_10/EMP20218193_2022_10_06_18_13_32.png',
                          size: 'full',
                          margin: 'lg'
                        }
                      ],
                      cornerRadius: '100px',
                      width: '72px',
                      height: '72px'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          contents: [
                            {
                              type: 'span',
                              text: 'อนุมัติ ' + item.welfareRequest,
                              weight: 'bold',
                              color: '#000000'
                            }
                          ],
                          size: 'sm',
                          wrap: true
                        },
                        {
                          type: 'text',
                          text: 'hello, world',
                          contents: [
                            {
                              type: 'span',
                              text: item.empFull_NameTH,
                              color: '#1A237E'
                            }
                          ]
                        },
                        {
                          type: 'text',
                          contents: [
                            {
                              type: 'span',
                              text: 'ยอดเบิก ' + item.welfareAmount,
                              weight: 'bold',
                              color: '#1A237E'
                            }
                          ]
                        },
                        {
                          type: 'text',
                          text: item.empFull_NameTH
                        }
                      ]
                    }
                  ],
                  spacing: 'xl',
                  paddingAll: '20px',
                  paddingTop: 'xs',
                  paddingBottom: 'xs'
                },
                {
                  type: 'separator'
                },
                {
                  type: 'box',
                  layout: 'baseline',
                  contents: [
                    {
                      type: 'text',
                      text: 'วันที่อนุมัติ',
                      flex: 1,
                      size: 'sm',
                      color: '#aaaaaa',
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: moment().format('YYYY-MM-DD'),
                      size: 'sm',
                      color: '#666666',
                      wrap: true,
                      flex: 1,
                      align: 'center'
                    }
                  ],
                  paddingTop: 'md'
                }
              ],
              paddingAll: '0px',
              offsetTop: 'xs',
              spacing: 'none'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบสถานะ',
                    uri: 'line://app/1654154168-JML0KbN5?page=WelfareHistory'
                  },
                  style: 'primary',
                  color: '#7CB342'
                }
              ]
            }
          }
        }
      ]
      await this.sendLinePush(payload, item.userLineuserId)
      this.dialogEdit = false
      await this.getData()
      this.dataReady = true
    },
    async deleteField (dt) {
      console.log('data', dt)
      console.log('ไฟล์ 1')
      this.dataReady = true
      this.$swal({
        title: 'ท่านต้องการ ' + 'ลบไฟล์' + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            welfareFile: dt.welfareFile,
            LAST_USER: this.session.data.userName
          }
          console.log('DS', ds)
          console.log('dt.welfareID', dt.welfareID)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/delete_file1/" + dt.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบไฟล์ เรียบร้อย', 'success')
              this.dialog = false
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    async deleteField2 (dt) {
      console.log('data', dt)
      console.log('ไฟล์ 2')
      this.dataReady = true
      this.$swal({
        title: 'ท่านต้องการ ' + 'ลบไฟล์' + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            welfareFile2: dt.welfareFile2,
            LAST_USER: this.session.data.userName
          }
          console.log('DS', ds)
          console.log('dt.welfareID', dt.welfareID)
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/delete_file2/" + dt.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบไฟล์ เรียบร้อย', 'success')
              this.dialog = false
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    async deleteField3 (dt) {
      console.log('data', dt)
      console.log('ไฟล์ 3')
      this.dataReady = true
      this.$swal({
        title: 'ท่านต้องการ ' + 'ลบไฟล์' + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            welfareFile3: dt.welfareFile3,
            LAST_USER: this.session.data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/delete_file3/" + dt.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบไฟล์ เรียบร้อย', 'success')
              this.dialog = false
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    async deleteField4 (dt) {
      console.log('data', dt)
      console.log('ไฟล์ 4')
      this.dataReady = true
      this.$swal({
        title: 'ท่านต้องการ ' + 'ลบไฟล์' + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            welfareFile4: dt.welfareFile4,
            LAST_USER: this.session.data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/delete_file4/" + dt.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบไฟล์ เรียบร้อย', 'success')
              this.dialog = false
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    async deleteField5 (dt) {
      console.log('data', dt)
      console.log('ไฟล์ 5')
      this.dataReady = true
      this.$swal({
        title: 'ท่านต้องการ ' + 'ลบไฟล์' + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            welfareFile5: dt.welfareFile5,
            LAST_USER: this.session.data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/delete_file5/" + dt.welfareID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ลบไฟล์ เรียบร้อย', 'success')
              this.dialog = false
              await this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)

          this.dataReady = true
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async getDataEmployee () {
      this.dataItemEmployee = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user/getList",
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            // s = d.empFull_NameTH
            s.value = d
            s.text = '[' + d.empCode + ']' + d.empFull_NameTH
            this.dataItemEmployee.push(s)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // this.formAdd.empCodeHeader = null
          console.log(error)
        })
    },
    async clearData () {
      this.formAdd.welfareAmount = null
      this.profile = null
      this.formAdd.welfareRequest = null
      this.file = null
      this.file2 = null
      this.file3 = null
      this.file4 = null
      this.file5 = null
    },
    async exportData () {
      var tem1 = []
      var tem2 = []
      var tem3 = []
      var tem4 = []
      var tem5 = []
      var tem6 = []
      var tem7 = []
      this.dataItem.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem1.push(s)
      })
      this.dataItemApprove.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem2.push(s)
      })
      this.dataItemUnApprove.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem3.push(s)
      })
      this.dataItemConfirm.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem4.push(s)
      })
      this.dataItemVerify.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem5.push(s)
      })
      this.dataItemAuditApprove.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem6.push(s)
      })
      this.dataItemCancel.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          ตำแหน่ง: element.positionName,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          สวัสดิการ: element.welfareRequest,
          ยอดเบิก: element.welfareAmount,
          หมายเหตุ: element.welfareRemark,
          วันที่ทำรายการ: element.CREATE_DATE,
          สถานะ: element.welfare_status
        }
        tem7.push(s)
      })
      var data = XLSX.utils.json_to_sheet(tem1)
      var approve = XLSX.utils.json_to_sheet(tem2)
      var unapprove = XLSX.utils.json_to_sheet(tem3)
      var confirm = XLSX.utils.json_to_sheet(tem4)
      var verify = XLSX.utils.json_to_sheet(tem5)
      var AuditApprove = XLSX.utils.json_to_sheet(tem6)
      var cancel = XLSX.utils.json_to_sheet(tem7)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รออนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'อนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, unapprove, 'ไม่อนุมัติ')
      XLSX.utils.book_append_sheet(wb, confirm, 'รอผจกHR')
      XLSX.utils.book_append_sheet(wb, verify, 'รอผจกสาขา')
      XLSX.utils.book_append_sheet(wb, AuditApprove, 'รอการเงิน')
      XLSX.utils.book_append_sheet(wb, cancel, 'ไม่ผ่าน')
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(
        wb,
        'รายการขอสวัสดิการ(' +
          this.day +
          ' ' +
          this.month +
          ' ' +
          this.year +
          ').xls'
      ) // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
.table-header {
  background-color: black;
}
table, th, td {
  border:1px solid black;
}
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
h3 {
  text-align: center;
}
.a >>> .ql-align-center {
  text-align: center;
}
.v-subheader {
  color: #c62929 !important;
}
a {
  color: #42b983;
}
#danger {
  color: red;
}
body {
  margin: 0;
  font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5385;
  color: #333;
  text-align: left;
  background-color: #eee;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.1875rem;
}

.card-img-actions {
  position: relative;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
  text-align: center;
}

.card-title {
  margin-top: 10px;
  font-size: 17px;
}

.invoice-color {
  color: red !important;
}

.card-header {
  padding: 0.9375rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

a {
  text-decoration: none !important;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

.header-elements-inline {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled > b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Welfare/welfareRequest.vue